import { useEffect, useState } from "react";
import { UseFormSetValue } from "react-hook-form";
import { IDropdownOption } from "../interfaces/iDropdown.interface";
import { IJobCreate } from "../interfaces/job/iJobCreate.interface";
import { API_URL } from "../config/config";
import { useApi } from "../api/useApi";

export function useLocationCascade(
  selectedRegionId: number,
  setValue: UseFormSetValue<IJobCreate>
) {
  const { request } = useApi();
  const [categories, setCategories] = useState<IDropdownOption[]>([]);
  const [regions, setRegions] = useState<IDropdownOption[]>([]);
  const [locations, setLocations] = useState<IDropdownOption[]>([]);

  // Load categories & regions on mount
  useEffect(() => {
    (async () => {
      try {
        const [catsRes, regsRes] = await Promise.all([
          request(`${API_URL}/jobCategory/jobCategoriesDropdown`),
          request(`${API_URL}/locationRegion/locationRegionsDropdown`),
        ]);
        if (catsRes.ok) setCategories(await catsRes.json());
        if (regsRes.ok) setRegions(await regsRes.json());
      } catch (e) {
        console.error(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Load locations when selected region changes
  useEffect(() => {
    if (!selectedRegionId || selectedRegionId === 0) {
      setLocations([]);
      setValue("locationId", 0);
      return;
    }
    (async () => {
      try {
        const res = await request(
          `${API_URL}/location/locationsByRegionDropdown?locationRegionId=${selectedRegionId}`
        );
        if (res.ok) setLocations(await res.json());
      } catch (e) {
        console.error(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRegionId, setValue]);

  return { categories, regions, locations };
}
